/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type WYSIWYGViewerWithFeatureFlag_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CustomProfileFieldsList_organization$ref: FragmentReference;
declare export opaque type CustomProfileFieldsList_organization$fragmentType: CustomProfileFieldsList_organization$ref;
export type CustomProfileFieldsList_organization = {|
  +$fragmentRefs: WYSIWYGViewerWithFeatureFlag_organization$ref,
  +$refType: CustomProfileFieldsList_organization$ref,
|};
export type CustomProfileFieldsList_organization$data = CustomProfileFieldsList_organization;
export type CustomProfileFieldsList_organization$key = {
  +$data?: CustomProfileFieldsList_organization$data,
  +$fragmentRefs: CustomProfileFieldsList_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomProfileFieldsList_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WYSIWYGViewerWithFeatureFlag_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '72e6b2da4667f16fb606261d1fdbd969';

module.exports = node;
